import { useCallback, useState } from "react";

import { DeleteBookingModalData } from "./delete_booking_modal";

type DeleteBookingModalDataStateType = {
  isOpen: boolean;
  data?: DeleteBookingModalData;
};

type DeleteBookingModalType = {
  state: DeleteBookingModalDataStateType;
  open: (data: DeleteBookingModalData) => void;
  close: () => void;
};

export const useDeleteBookingModal = (): DeleteBookingModalType => {
  const [modalData, setModalData] = useState<DeleteBookingModalDataStateType>({ isOpen: false });

  const open = useCallback((data: DeleteBookingModalData) => setModalData({ isOpen: true, data }), []);

  const close = useCallback(() => setModalData({ isOpen: false }), []);

  return { open, close, state: modalData };
};
